import qs from "query-string";
import { useLocation } from "react-router-dom";
import RequestsReport from "./Request";
import SettlmentList from "./Settlement/List";
import { BaseSettlementQSType } from "./types";

export const SettlementList = () => {
  const location = useLocation();
  const { segment = "settlement" } = qs.parse(location.search) as BaseSettlementQSType;

  return segment === "settlement" ? <SettlmentList /> : <RequestsReport />;
};

export default SettlementList;
